var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.item ? _c('div', [_vm.hasOpenDetailListener() ? _c(_vm.refComponentName, {
    ref: "refDetail",
    tag: "component",
    attrs: {
      "item": _vm.item,
      "small": _vm.small,
      "confirmable": _vm.confirmable
    },
    on: {
      "openDetail": _vm.emitOpenDetail
    }
  }) : _c(_vm.refComponentName, {
    ref: "refDetail",
    tag: "component",
    attrs: {
      "item": _vm.item,
      "small": _vm.small,
      "confirmable": _vm.confirmable
    }
  })], 1) : _vm.loading ? _c('v-skeleton-loader', {
    staticClass: "mx-auto",
    attrs: {
      "type": "paragraph"
    }
  }) : _vm.loadedItem ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm.hasOpenDetailListener() ? _c(_vm.refComponentName, {
    ref: "refDetail",
    tag: "component",
    attrs: {
      "item": _vm.loadedItem,
      "small": _vm.small,
      "confirmable": _vm.confirmable
    },
    on: {
      "openDetail": _vm.emitOpenDetail
    }
  }) : _c(_vm.refComponentName, {
    ref: "refDetail",
    tag: "component",
    attrs: {
      "item": _vm.loadedItem,
      "small": _vm.small,
      "confirmable": _vm.confirmable
    }
  })], 1) : _c('latest-entries-card-empty');
}
var staticRenderFns = []

export { render, staticRenderFns }